import lore1 from '../assets/lore/lore1.png';
import lore2 from '../assets/lore/lore2.png';
import lore3 from '../assets/lore/lore3.png';
import lore4 from '../assets/lore/lore4.png';
import lore5 from '../assets/lore/lore5.png';
import lore6 from '../assets/lore/lore6.png';
import lore7 from '../assets/lore/lore7.png';

// Keep this list in numeric order.
// To add more illustrations later, import the new file here and append it below.
const loreIllustrationSources = [lore1, lore2, lore3, lore4, lore5, lore6, lore7].filter(Boolean);

export function getLoreIllustrationSources() {
  return loreIllustrationSources;
}

function clampIllustrationIndex(index, length) {
  if (!length) return 0;
  const parsed = Math.floor(Number(index) || 0);
  if (parsed <= 0) return 0;
  return Math.min(length - 1, parsed);
}

function normalizeRoll(randomFn) {
  const roll = typeof randomFn === 'function' ? randomFn() : Math.random();
  if (!Number.isFinite(roll)) return Math.random();
  if (roll <= 0) return 0;
  if (roll >= 1) return 0.999999;
  return roll;
}

function hashLoreKey(key) {
  const text = String(key || '');
  let hash = 2166136261;

  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  return hash >>> 0;
}

function pickLoreIllustrationByIndex(index) {
  if (!loreIllustrationSources.length) return null;
  return loreIllustrationSources[clampIllustrationIndex(index, loreIllustrationSources.length)] || loreIllustrationSources[0] || null;
}

export function pickRandomLoreIllustration(randomFn = Math.random) {
  if (!loreIllustrationSources.length) return null;

  const index = Math.floor(normalizeRoll(randomFn) * loreIllustrationSources.length);
  return pickLoreIllustrationByIndex(index);
}

export function pickStableLoreIllustration(key) {
  if (!loreIllustrationSources.length) return null;

  const hash = hashLoreKey(key);
  const index = hash % loreIllustrationSources.length;
  return pickLoreIllustrationByIndex(index);
}
